import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetStaticProps } from 'next';
import { ReactElement } from 'react';
import { seconds } from 'utils';
import locale from '~/constants/locale.mjs';
import { DynamicLayout } from '~/layout';
import { queryResolver } from '~/services/query-resolver';
import { DynamicPageProps } from '~/types';

const fallbackLocale = locale.defaultLocale;

export const getStaticProps: GetStaticProps<DynamicPageProps> = async (context) => {
    const { locale, defaultLocale = fallbackLocale } = context;
    const currentLocale = locale || defaultLocale;

    const queryClientPage = new QueryClient();
    await queryResolver({ locale: currentLocale, slug: ['500'], queryClientPage });

    return {
        revalidate: seconds(30, true),
        props: {
            dehydratedState: dehydrate(queryClientPage),
        },
    };
};

/**
 * The frontend has no awareness over what pages exist so we rely on the
 * CMS to provide us with the 500 page. In cases the page is not found the CMS will
 * return the configured 500 page.
 */
export default function ErrorPage() {
    return <div>500</div>;
}

ErrorPage.getLayout = function getLayout(page: ReactElement) {
    return <DynamicLayout>{page}</DynamicLayout>;
};